"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _setStatic = _interopRequireDefault(require("recompose/setStatic"));

var _setDisplayName = _interopRequireDefault(require("recompose/setDisplayName"));

var _Slide = _interopRequireDefault(require("rsuite-utils/lib/Animation/Slide"));

var _Modal = _interopRequireDefault(require("./Modal"));

var _ModalBody = _interopRequireDefault(require("./ModalBody"));

var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));

var _ModalTitle = _interopRequireDefault(require("./ModalTitle"));

var _ModalFooter = _interopRequireDefault(require("./ModalFooter"));

var _utils = require("./utils");

var Drawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2["default"])(Drawer, _React$Component);

  function Drawer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Drawer.prototype;

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        show = _this$props.show,
        full = _this$props.full,
        className = _this$props.className,
        placement = _this$props.placement,
        classPrefix = _this$props.classPrefix,
        props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["show", "full", "className", "placement", "classPrefix"]);
    var addPrefix = (0, _utils.prefix)(classPrefix);
    var classes = (0, _classnames["default"])(addPrefix(placement), className, (_classNames = {}, _classNames[addPrefix('full')] = full, _classNames));
    var animationProps = {
      placement: placement
    };
    return React.createElement(_Modal["default"], (0, _extends2["default"])({}, props, {
      drawer: true,
      classPrefix: classPrefix,
      className: classes,
      show: show,
      animation: _Slide["default"],
      animationProps: animationProps
    }));
  };

  return Drawer;
}(React.Component);

(0, _defineProperty2["default"])(Drawer, "defaultProps", {
  placement: 'right'
});
(0, _defineProperty2["default"])(Drawer, "handledProps", ["children", "className", "classPrefix", "full", "placement", "show"]);
var EnhancedDrawer = (0, _utils.defaultProps)({
  classPrefix: 'drawer'
})(Drawer);
var EnhancedBody = (0, _utils.defaultProps)({
  classPrefix: 'drawer-body'
})(_ModalBody["default"]);
(0, _setStatic["default"])('Body', (0, _setDisplayName["default"])('Body')(EnhancedBody))(EnhancedDrawer);
(0, _setStatic["default"])('Header', (0, _utils.defaultProps)({
  classPrefix: 'drawer-header'
})(_ModalHeader["default"]))(EnhancedDrawer);
(0, _setStatic["default"])('Title', (0, _utils.defaultProps)({
  classPrefix: 'drawer-title'
})(_ModalTitle["default"]))(EnhancedDrawer);
(0, _setStatic["default"])('Footer', (0, _utils.defaultProps)({
  classPrefix: 'drawer-footer'
})(_ModalFooter["default"]))(EnhancedDrawer);
var _default = EnhancedDrawer;
exports["default"] = _default;